document.addEventListener('DOMContentLoaded', function() {
  // CONFIGURACIÓN: ¿Cómo se llaman tus opciones en Shopify?
  // Ajusta esto si Edson usa otros nombres en el Excel.
  const targetOption1 = "Color";    // La que manda (Ej. Color)
  const targetOption2 = "Material"; // La que cambia (Ej. Material)

  const productJsonScript = document.querySelector('[id^="ProductVariantsJson-"]');
  if (!productJsonScript) return; // Si no hay datos, no hacemos nada.

  const variants = JSON.parse(productJsonScript.textContent);
  
  // Detectar el formulario de variantes
  // Nota: En temas 2.0 los inputs suelen ser type="radio" o <select>
  const option1Inputs = document.querySelectorAll(`input[name="${targetOption1}"], select[name="${targetOption1}"]`);
  
  if (option1Inputs.length === 0) return;

  // Función principal: Actualizar disponibilidad
  function updateLinkedOptions(selectedColor) {
    // 1. Filtrar variantes que coincidan con el color seleccionado
    const validVariants = variants.filter(variant => {
      // Shopify guarda las opciones en option1, option2, option3
      // Necesitamos saber en qué posición está "Color" y "Material"
      // Por simplicidad, asumiremos el orden estándar o buscaremos por valor
      return variant.option1 === selectedColor || variant.option2 === selectedColor;
    });

    // 2. Obtener lista de materiales válidos para ese color
    const validMaterials = validVariants.map(variant => {
      // Si el color era option1, el material es option2 (y viceversa)
      return variant.option1 === selectedColor ? variant.option2 : variant.option1;
    }).filter(item => item !== selectedColor); // Limpieza por seguridad

    // 3. Buscar los inputs de Material y bloquear los inválidos
    const materialInputs = document.querySelectorAll(`input[name="${targetOption2}"], select[name="${targetOption2}"] option`);
    
    // CASO A: Botones (Radio Inputs)
    document.querySelectorAll(`input[name="${targetOption2}"]`).forEach(input => {
      const materialValue = input.value;
      const label = document.querySelector(`label[for="${input.id}"]`);
      
      if (validMaterials.includes(materialValue)) {
        // DISPONIBLE
        input.disabled = false;
        input.parentElement.classList.remove('disabled', 'unavailable');
        if(label) label.style.opacity = '1';
        if(label) label.style.textDecoration = 'none';
      } else {
        // NO DISPONIBLE
        input.disabled = true;
        input.checked = false; // Desmarcar si estaba seleccionado
        input.parentElement.classList.add('disabled', 'unavailable');
        if(label) label.style.opacity = '0.4';
        if(label) label.style.textDecoration = 'line-through'; // Tachado visual
      }
    });

    // CASO B: Lista desplegable (Select) - Si usas dropdowns
    const materialSelect = document.querySelector(`select[name="${targetOption2}"]`);
    if (materialSelect) {
      Array.from(materialSelect.options).forEach(option => {
        if (validMaterials.includes(option.value)) {
          option.disabled = false;
          option.hidden = false;
        } else {
          option.disabled = true;
          option.hidden = true;
          if (option.selected) materialSelect.value = ""; // Resetear selección
        }
      });
    }
    
    // 4. (Opcional) Auto-seleccionar el primer material válido disponible
    // Esto es muy útil para que el usuario no vea "nada seleccionado" al cambiar de color.
    const firstValidInput = document.querySelector(`input[name="${targetOption2}"]:not(:disabled)`);
    if (firstValidInput && !document.querySelector(`input[name="${targetOption2}"]:checked`)) {
        firstValidInput.click(); // Forzamos click para activar eventos de tema
    }
  }

  // EVENT LISTENERS (Escuchar cambios)
  option1Inputs.forEach(input => {
    input.addEventListener('change', (e) => {
      updateLinkedOptions(e.target.value);
    });
  });

  // EJECUTAR AL INICIO (Para filtrar según la selección inicial)
  const initialSelection = document.querySelector(`input[name="${targetOption1}"]:checked, select[name="${targetOption1}"]`);
  if (initialSelection) {
    updateLinkedOptions(initialSelection.value);
  }
});